<template>
	<v-card v-can="'user.read'">
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$cardAccount"
				start
			/>
			<translate>Customer details</translate>
		</v-card-title>
		<v-card-text>
			<v-table>
				<tbody>
					<tr>
						<td>
							<v-icon
								icon="$user"
								start
							/>
							<strong>
								<a :href="`/bo/users/view?id=${user.id}`"><translate>{{ user.preamble }}</translate> {{ user.fullName }}</a>
							</strong>
						</td>
					</tr>
					<tr>
						<td>
							<v-icon
								icon="$user"
								start
							/>
							<translate>Customer Number</translate>:
							<translate>{{ user.id }}</translate>
						</td>
						<td>
							<v-btn
								variant="outlined"
								color="primary"
								class="js_copytoclipboard pull-right"
								:data-clipboard-text="user.id"
							>
								<translate>Copy Customer Number</translate>
							</v-btn>
						</td>
					</tr>
					<tr>
						<td v-if="user.alternativeAddressLine1">
							<v-icon
								icon="$home"
								start
							/>
							<del>
								{{ user.addressLine1 }}<br>
								{{ user.addressLine2 }}<br>
								<translate>{{ user.country }}</translate>
							</del>
						</td>
						<td v-else>
							<v-icon
								icon="$home"
								start
							/>
							{{ user.addressLine1 }}<br>
							{{ user.addressLine2 }}<br>
							<translate>{{ user.country }}</translate>
							<address-modal
								v-if="claimId"
								:claimid="claimId"
							/>
						</td>
						<td v-if="user.alternativeAddressLine1">
							<strong><translate>Temporary delivery address</translate>:</strong><br>
							{{ user.alternativeAddressLine1 }}<br>
							{{ user.alternativeAddressLine2 }}<br>
							<translate>{{ user.alternativeCountry }}</translate>
							<address-modal
								v-if="claimId"
								:claimid="claimId"
							/>
						</td>
					</tr>
					<tr>
						<td>
							<v-icon
								icon="$calendar"
								start
							/>
							{{ user.dateBirth }}
						</td>
					</tr>
					<tr>
						<td>
							<v-icon
								icon="$email"
								start
							/>
							<a :href="`mailto:${user.email}`">{{ user.email }}</a>
						</td>
						<td>
							<v-btn
								variant="outlined"
								color="primary"
								class="pull-right"
								:disabled="user.hasToken"
								@click="sendActivationEmail"
							>
								<translate>Send Activation Email</translate>
							</v-btn>
						</td>
					</tr>
					<tr
						v-for="(number, index) in user.telephonenumbers"
						:key="index"
					>
						<td>
							<v-icon
								icon="$mobile"
								start
							/>
							<a :href="`callto:${number}`">{{ number }}</a>
						</td>
						<td v-if="index === 0 && user.alternativeNumber">
							<strong><translate>Preferred Number</translate>:</strong> <a :href="`callto:${user.alternativeNumber}`">{{ user.alternativeNumber }}</a>
						</td>
					</tr>
					<tr>
						<td>
							<v-row>
								<v-col cols="auto">
									<v-img
										v-if="user.icon"
										:src="`/images/flags/${user.icon}.svg`"
										width="16px"
										height="16px"
										start
									/>
								</v-col>
								<v-col class="pl-0">
									{{ user.language }}
								</v-col>
							</v-row>
						</td>
					</tr>
				</tbody>
			</v-table>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import AddressModal from '../molecules/AddressModal.vue';

export default {
	name: 'CustomerDetails',
	components: {
		AddressModal
	},
	props: {
		userId: {
			type: String,
			required: true
		},
		orderId: {
			type: String,
			required: false,
			default: ''
		},
		claimId: {
			type: String,
			required: false,
			default: ''
		}
	},

	data () {
		return {
			user: {
			},
		};
	},

	mounted () {
		this.retrieveUserInfo();
	},

	methods: {
		/**
		 * Retrieve the user's information
		 */
		retrieveUserInfo () {
			axios.get(`/api/v0/users/customerdetails?id=${this.userId}&order_id=${this.orderId}`)
				.then(({
					data
				}) => {
					this.user = data;
				})
				.catch((error) => {
					window.captureException(error);
				});
		},

		/**
		 *
		 */
		sendActivationEmail () {
			const formData = new FormData();

			formData.append('email_address', this.user.email);
			formData.append('csrf_token', this.$csrfToken);

			axios.post('/welcome/doActivation', formData)
				.catch((error) => {
					window.captureException(error);
				});
		}
	}
};

</script>
<style scoped>
.v-table ::v-deep(.v-table__wrapper) {
	overflow: hidden;
}
</style>
